// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","268":"9b285714","453":"d456ce70","455":"425c09da","950":"8d54834d","977":"f71b7a63"}[chunkId] + ".chunk.js";
};